module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Light.409c7f7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Light.ttf
// module id = Mmzy
// module chunks = 1